import React, { useState, useEffect } from "react";
import { Card, CardBody, Button } from "reactstrap";
import ReactApexChart from "react-apexcharts";
import { getRecords } from "../../services/api.service";
import { useNavigate } from "react-router-dom";

const Category = () => {
  const navigate = useNavigate();
  const [series, setSeries] = useState([]);
  const [options, setOptions] = useState({
    labels: [],
    colors: [],
    chart: { type: "donut" },
    plotOptions: { pie: { donut: { size: "75%" } } },
    dataLabels: { enabled: false },
    legend: { show: true, position: "bottom" },
    fill: { colors: [] },
  });
  const [loading, setLoading] = useState(true);
  const [isFetch, setIsFetch] = useState(false);

  // Skeleton styles
  const skeletonStyle = {
    backgroundColor: "#f0f0f0",
    borderRadius: "4px",
    position: "relative",
    overflow: "hidden",
    background: "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
    backgroundSize: "200% 100%",
    animation: "shimmer 1.5s infinite linear",
  };

  useEffect(() => {
    let timer;

    const fetchData = async () => {
      if (!isFetch) {
        setLoading(true);
        await fetchReports();
        setLoading(false);
      }
    };

    timer = setTimeout(fetchData, 3000);

    const handleStorageChange = () => {
      fetchReports().finally(() => setLoading(false));
      setIsFetch(true);
    };

    window.addEventListener("dashboardUpdate", handleStorageChange);

    return () => {
      clearTimeout(timer);
      window.removeEventListener("dashboardUpdate", handleStorageChange);
    };
  }, [isFetch]); // Added

  useEffect(() => {
    if (series.length > 0) {
      setOptions((prev) => ({ ...prev }));
    }
  }, [series]);


  
  const formatCompactNumber = (number) => {
    if (typeof number !== "number") {
      // Extract number from string if needed (e.g., "47000" from "Agriculture (47000)")
      const numMatch = number.toString().match(/\d+/);
      number = numMatch ? parseInt(numMatch[0]) : 0;
    }

    if (number >= 10000000) return (number / 10000000).toFixed(1) + "cr";
    if (number >= 100000) return (number / 100000).toFixed(1) + "L";
    if (number >= 1000) return (number / 1000).toFixed(1) + "k";
    return number.toString();
  };

  const fetchReports = async () => {
    try {
      const dashboard_details = localStorage.getItem("dashboard_details");
      if (!dashboard_details) {
        setSeries([]);
        return;
      }

      const payload = JSON.parse(dashboard_details);
      const response = await getRecords(
        payload,
        "/dashboard/getCategoryWiseStockCount"
      );

      if (response.code === 1 && response.data) {
        let { label, value, color } = response.data;

        if (!Array.isArray(label) || !Array.isArray(value)) {
          console.error("Invalid API data format. Expected arrays.");
          return;
        }

        // Process labels and extract values
        const processedData = label.map((labelStr, index) => {
          // Extract category name and value from strings like "Agriculture (47000)"
          const match = labelStr.match(/^(.*?)\s*\((\d+)\)$/);
          const category = match ? match[1].trim() : labelStr;
          const numValue = match ? parseInt(match[2]) : value[index] || 0;

          return {
            category,
            value: numValue,
            formattedValue: formatCompactNumber(numValue),
          };
        });

        // Set chart data
        setSeries(processedData.map((item) => item.value));
        setOptions((prev) => ({
          ...prev,
          labels: processedData.map(
            (item) => `${item.category} (${item.formattedValue})`
          ),
          colors:
            color?.length === label.length
              ? [...color]
              : label.map(
                  () => `#${Math.floor(Math.random() * 16777215).toString(16)}`
                ),
          fill: {
            colors: color?.length === label.length ? [...color] : undefined,
          },
        }));
      } else {
        setSeries([]);
        setOptions((prev) => ({
          ...prev,
          labels: ["No Data"],
          colors: ["#d3d3d3"],
          fill: { colors: ["#d3d3d3"] },
        }));
      }
    } catch (error) {
      console.error("Error fetching category data:", error);
    }
  };

  // const fetchReports = async () => {
  //   try {
  //     const dashboard_details = localStorage.getItem("dashboard_details");
  //     if (!dashboard_details) {
  //       setSeries([]);
  //       return;
  //     }

  //     const payload = JSON.parse(dashboard_details);
  //     const response = await getRecords(
  //       payload,
  //       "/dashboard/getCategoryWiseStockCount"
  //     );

  //     if (response.code === 1 && response.data) {
  //       let { label, value, color } = response.data;

  //       if (
  //         !Array.isArray(label) ||
  //         !Array.isArray(value) ||
  //         !Array.isArray(color)
  //       ) {
  //         console.error("Invalid API data format. Expected arrays.");
  //         return;
  //       }


  //       // const formattedLabels = label.map((l, i) => {
  //       //   return `${l} (${formatNumber(value[i])})`;
  //       // });

  //       value = value.map((v) => (typeof v === "number" ? v : 0));

  //       if (color.length !== label.length) {
  //         color = label.map(
  //           () => `#${Math.floor(Math.random() * 16777215).toString(16)}`
  //         );
  //       }
  //       console.log("label", label);
 

        

  //       setSeries([...value]);
  //       setOptions((prev) => ({
  //         ...prev,
  //         //  labels: formattedLabels, 
  //         labels: [...label],
  //         colors: [...color],
  //         fill: { colors: color },
  //       }));
  //     } else {
  //       setSeries([]);
  //       setOptions((prev) => ({
  //         ...prev,
  //         labels: ["No Data"],
  //         colors: ["#d3d3d3"],
  //         fill: { colors: ["#d3d3d3"] },
  //       }));
  //     }
  //   } catch (error) {
  //     console.error("Error fetching category data:", error);
  //   } finally {
  //     // setLoading(false);
  //   }
  // };

  return (
    <Card>
      <CardBody>
        <style>
          {`
            @keyframes shimmer {
              to { background-position: -200% 0; }
            }
          `}
        </style>

        {loading ? (
          <>
            <h4
              className=""
              style={{
                ...skeletonStyle,
                width: "100px",
                height: "24px",
              }}></h4>

            <div id="donut-chart" className="apex-charts">
              <div
                style={{
                  ...skeletonStyle,
                  height: "480px",
                  width: "100%",
                  borderRadius: "8px",
                }}
              />
            </div>
          </>
        ) : series.length > 0 ? (
          <>
            <h4 className="card-title mb-4">Category Wise Stocks</h4>

            <ReactApexChart
              key={series.join()}
              options={options}
              series={series}
              type="donut"
              height={480}
            />
          </>
        ) : (
          <p className="text-center">No Data Available</p>
        )}

        <div className="d-flex justify-content-end mt-2">
          {loading ? (
            <div
              style={{
                ...skeletonStyle,
                width: "100px",
                height: "24px",
              }}
            />
          ) : (
            <Button
              color="link"
              className="fw-bold p-0 text-decoration-none"
              onClick={() => navigate("/category-wise-stocks")}>
              Details <i className="ri-arrow-right-line fs-5 ms-1"></i>
            </Button>
          )}
        </div>
      </CardBody>
    </Card>
  );
};

export default Category;
